import script from "./DqAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./DqAvatar.vue?vue&type=script&setup=true&lang=js"

import "./DqAvatar.vue?vue&type=style&index=0&id=a2f60060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2f60060"]])

export default __exports__